// frontend/src/api/user.js
import { useResolvedPath } from 'react-router-dom';
import apiClient from './apiClient';

export const createUser = async (userData) => {
  const response = await apiClient.post('/users/', userData);
  return response.data;
};

export const validateInviteCode = async (code) => {
  const response = await apiClient.post('/invite_code/', { code });
  return response.data;
};

export const generatePubCode = async () => {
  const response = await apiClient.post('/generatePubCode/');
  return response.data;
};

export const registerParticipant = async (data) => {
  const response = await apiClient.post('/form_pd/', data);
  console.log('registerParticipant response:', response.data);
  return response.data;
};

export const submitMountainData = async (data) => {
  const response = await apiClient.post('/mountain_data/', data);
  return response.data;
};

export const createEmergencyContact = async (data) => {
  const response = await apiClient.post('/emergency_contact/', data);
  return response.data;
};

export const finalizeRegistration = async (data) => {
  const response = await apiClient.post('/finalize_registration/', data);
  return response.data;
};

export const login = async (data) => {
  const response = await apiClient.post('/login_landing/', data);
  return response.data;
};

export const logout = async (data) => {
  const response = await apiClient.post('/logout_landing/', data);
  return response.data;
};

export const me = async (data) => {
  const response = await apiClient.get('/me/', data);
  return response.data;
};

export const weather = async (data) => {
  const response = await apiClient.get('/weather/', data);
  return response.data;
};

export const profile_data = async (data) => {
  const response = await apiClient.get('/profile_data/', data);
  return response.data;
};

export const notifications = async (data) => {
  const response = await apiClient.get('/notificaciones/', data);
  return response.data;
};

export const liftPassNumPost = async (data) => {
  const response = await apiClient.post('/lift-pass-number/', data);
  return response.data;
};

export const liftPassNumGet = async (data) => {
  const response = await apiClient.get('/lift-pass-number/', data);
  return response.data;
};

export const liftpassGet = async () => {
  const response = await apiClient.get("/liftpassimg/", {
    responseType: "blob",
  });

  return response.data;
};

export const liftpassPost = async (file) => {
  const formData = new FormData();
  formData.append("file", file);

  const response = await apiClient.post("/liftpassimg/", formData, {
    headers: {
      "Content-Type": "multipart/form-data",
    },
  });

  return response.data;
};


export const recoverPassword = async (data) => {
  const response = await apiClient.post('/password-reset-request/', data);
  return response.data;
};

export const resetPassword = async (data) => {
  const response = await apiClient.post('/password-reset-confirm/', data);
  return response.data;
};

// api/user.js
export const getRankings = async (filters) => {
  // Use the 'params' key so axios appends them to the URL: /getRankings/?activity=SKI...
  const response = await apiClient.get('/getRankings/', { params: filters });
  return response.data;
};